var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95 13.9C2.2 13.9 0 11.7 0 8.95C0 6.2 2.2 4 4.95 4H10.75C13.5 4 15.7 6.2 15.7 8.95C15.7 11.7 13.5 13.9 10.75 13.9H4.95ZM10.6 12.15C12.4 12.15 13.8 10.7 13.8 8.95C13.8 7.15 12.35 5.75 10.6 5.75H5.1C3.3 5.75 1.9 7.2 1.9 8.95C1.9 10.7 3.35 12.15 5.1 12.15H10.6Z",
    fill: "#C74634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOci);
export default __webpack_public_path__ + "static/media/Logo_oci.dd9e3f70564785624ed58b1befc8278c.svg";
export { ForwardRef as ReactComponent };